import { HeadCell } from '../../../models/TableProps';
import { MyQuotationDetailsHead } from '../../../models/quotations/MyQuotation';

export const quotationDetailsProductTableHead: HeadCell<MyQuotationDetailsHead>[] =
    [
        {
            id: 'description',
            numeric: false,
            disablePadding: false,
            label: 'DESCRIPTION',
            sortable: true,
        },
        {
            id: 'quantity',
            numeric: true,
            disablePadding: false,
            label: 'QUANTITY',
            sortable: true,
        },
        {
            id: 'netUnitPrice',
            numeric: true,
            disablePadding: false,
            label: 'NET_UNIT_PRICE',
            sortable: true,
        },
        {
            id: 'netLineAmount',
            numeric: true,
            disablePadding: false,
            label: 'NET_LINE_AMOUNT',
            sortable: true,
        },
        {
            id: 'vat',
            numeric: true,
            disablePadding: false,
            label: 'VAT',
            sortable: true,
        },
        {
            id: 'grossPrice',
            numeric: true,
            disablePadding: false,
            label: 'GROSS_AMOUNT',
            sortable: true,
        },
    ];
